import { useRef, useEffect, useState } from 'react';
import { HTTP_METHOD, getDefaultOptions } from '../async/GetAsyncOptions';
import { IAppConfig } from '../interface/IAppConfig';

export const useCustomerMarking = (props: IAppConfig, customerHasMarking: boolean | null) => {
  const isLoggedOn = window.topContext.user.isLoggedOn;
  const [customerMarking, setCustomerMarking] = useState<boolean | undefined>(undefined);
  const [error, setError] = useState<unknown>(false);
  const isLoading = useRef(false);

  useEffect(() => {
    const fetchCustomerMarking = async () => {
      isLoading.current = true;
      const options = getDefaultOptions(HTTP_METHOD.GET, props, 'wso2Secured');
      try {
        const response = await fetch(
          `${props.apiGatewayBase}/v2/onlinesales-services/api/customer/kundemarkering?product=travel`,
          options
        );

        if (response.ok) {
          const data = await response.json();
          setCustomerMarking(!data.canProceed);
        } else {
          setError(true);
          setCustomerMarking(false);
        }
      } catch (error) {
        setError(error);
        setCustomerMarking(false);
      } finally {
        isLoading.current = false;
      }
    };

    if (!isLoading.current && isLoggedOn && customerHasMarking === null) {
      fetchCustomerMarking();
    }
  }, [props, customerHasMarking, isLoggedOn]);

  return { customerMarking, isLoading: isLoading.current, error };
};
